import { useLoaderData } from "react-router";
import CustomError from "@components/Error/CustomError";
import { EventsAwardsGalleryPageContext } from "@events-awards/EventsAwardsGallery/utils/types";
import { getAwardType } from "@events-awards/utils/helpers";
import { MetaDescriptorProps } from "@features/seo/utils/types";
import { Route } from "@route-types/Section/layouts/EventsAwards/EventsAwardsGallery/+types/EventsAwardsGalleryPage";
import { ResponseType } from "@sphtech/web2-core/ssr";
import { createMetaTags } from "@sphtech/web2-seo-schema";
import { HttpStatusCode } from "axios";

import { fetchEventsAwardsGalleryPageData } from "./EventsAwardsGalleryPage.server";
import EventsAwardsGalleryPageContent from "./EventsAwardsGalleryPageContent";

/** This is the main entry point component for /events-awards route. */
const EventsAwardsGalleryPage = (): React.ReactElement => {
  const context = useLoaderData<EventsAwardsGalleryPageContext>();

  // StatusCode is not 200
  if (context && context.statusCode !== HttpStatusCode.Ok) {
    return <CustomError statusCode={context.statusCode} />;
  }

  // Check if payload is missing
  if (typeof context?.payload === "undefined") {
    return <CustomError statusCode={HttpStatusCode.NotFound} />;
  }

  return (
    <EventsAwardsGalleryPageContent
      {...context.payload.data}
      gaProps={context.payload.gaProps}
    />
  );
};

export default EventsAwardsGalleryPage;

export const loader = async ({ request }: Route.LoaderArgs) => {
  const url = new URL(request.url, `http://localhost`);
  const path = url.pathname;

  return await fetchEventsAwardsGalleryPageData(getAwardType(path));
};

export const meta = ({ loaderData }: Route.MetaArgs): MetaDescriptorProps[] => {
  const context = loaderData as EventsAwardsGalleryPageContext;

  if (context.type !== ResponseType.SUCCESS) return [];

  const data = context.payload;

  if (!data) return [];
  if (!data.metaTags) return [];

  return createMetaTags(data.metaTags);
};
